import React from 'react';
import DOMPurify from 'dompurify';
import SubscriptionShimmer from './SubscriptionShimmer';

const money = (value) => `₹${Number(value || 0).toFixed(2)}`;

export default function AssessmentMySubscription({ subscriptions = [], loading, error, onRetry }) {
  return <section className="select-planA assessment-owned">
    <div className="assessment-owned__section-heading">
      <h2 className="select-plan__titleA">My Subscription</h2>
      {!loading && !error && subscriptions.length > 0 && <span>{subscriptions.length} {subscriptions.length === 1 ? 'plan' : 'plans'}</span>}
    </div>
    {loading ? <SubscriptionShimmer kind="assessmentOwned" /> : error ? (
      <div className="assessment-owned__state" role="alert">
        <span className="assessment-owned__state-icon"><i className="bi bi-exclamation-circle" aria-hidden="true" /></span>
        <h3>Unable to load subscriptions</h3>
        <p>{error.message}</p>
        <button type="button" onClick={onRetry}>Try again</button>
      </div>
    ) : !subscriptions.length ? (
      <div className="assessment-owned__state">
        <span className="assessment-owned__state-icon"><i className="bi bi-card-checklist" aria-hidden="true" /></span>
        <h3>No active assessment subscriptions</h3>
        <p>Plans you purchase will appear here with their validity and included assessments.</p>
      </div>
    ) : (
      <div className="select-plan__listA">{subscriptions.map((plan, index) => {
        const included = (Array.isArray(plan.quiz_types) ? plan.quiz_types : []).filter((item) => Number(item.selected) === 1);
        return <article className="test-plan-cardA assessment-owned__card" key={plan.subscription_id || `${plan.plan_id}-${index}`}>
          <div className="assessment-owned__card-heading"><h3>{plan.plan_name}</h3><span><i className="bi bi-check-circle-fill" aria-hidden="true" /> Purchased</span></div>
          <div className="assessment-owned__price"><strong>{money(plan.payment_paid)}</strong>{plan.plan_duration && <span>{plan.plan_duration}</span>}</div>
          <div className="assessment-owned__dates"><div><span>Purchased on</span><strong>{plan.purchase_date || '—'}</strong></div><div><span>Valid until</span><strong>{plan.expiry_date || '—'}</strong></div></div>
          {plan.plan_description && <details className="assessment-owned__about"><summary>About this plan <i className="bi bi-chevron-down" aria-hidden="true" /></summary><div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(String(plan.plan_description)) }} /></details>}
          {included.length > 0 && <div className="assessment-owned__inclusions"><h4>Included assessments</h4><div className="assessment-owned__inclusion-list">{included.map((item, itemIndex) => <span key={item.id || `${item.name}-${itemIndex}`}><i className="bi bi-check-circle-fill" aria-hidden="true" />{item.name}</span>)}</div></div>}
        </article>;
      })}</div>
    )}
  </section>;
}
